import { GlobalAxios } from "../axios/axios-config";
import { IDomainValue } from "../models/domain-value";

const DOMAIN_VALUE_ROUTE =
  process.env.REACT_APP_EXTERNAL + "/api/v1/DomainValue";

export const domainValueList = (params?: any) => {
  return GlobalAxios.get<IDomainValue[]>(DOMAIN_VALUE_ROUTE + "/DomainValue", {
    params: params,
    paramsSerializer: { indexes: null },
  });
};
